'use strict';

var styled = require('styled-components');
var animations = require('../../../theme/animations.js');
var index = require('../../Flex/index.js');
var component$1 = require('../../Icon/component.js');
require('react');
require('../../Tooltip/component.js');
var component = require('../../Text/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const FilenameContainer = styled__default.default(index.Flex.Row) `
  color: ${({ theme, disabled }) => disabled ? theme.designTokens.fileDisabledNameTextColor : theme.designTokens.fileNameTextColor};
  background: ${({ theme, errored }) => errored ? theme.designTokens.fileNameErrorBackgroundColor : theme.designTokens.fileNameBackgroundColor};
  border-radius: ${({ theme }) => theme.designTokens.fileNameBorderRadius};
  padding: ${({ theme }) => theme.designTokens.fileNamePaddingY} ${({ theme }) => theme.designTokens.fileNamePaddingX};
  border: 1px solid transparent;
`;
const HiddenInput = styled__default.default.input `
  display: none;
`;
const FilenameText = styled__default.default(component.Text) `
  ${({ disabled, theme }) => disabled && `color: ${theme.designTokens.fileDisabledNameTextColor};`}
`;
const ClearIcon = styled__default.default(component$1.Icon).withConfig({
    shouldForwardProp: prop => prop !== 'errored',
}) `
  cursor: pointer;
  font-size: 10px;
  ${({ errored, theme }) => errored && `color: ${theme.designTokens.fileNameErrorIconColor};`}
`;
const LoadingIcon = styled__default.default(component$1.Icon) `
  animation: ${animations.animations.hourglass} 1.5s linear infinite;
`;
const ValidIcon = styled__default.default(component$1.Icon) `
  color: ${({ theme }) => theme.designTokens.fileNameValidIconColor};
`;
const Styled = {
    FilenameContainer,
    HiddenInput,
    ClearIcon,
    LoadingIcon,
    FilenameText,
    ValidIcon,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
